export default __webpack_public_path__ + "static/media/portfolio.09eb44fa.png";